/**
 * Subpath-aware public-asset URL.
 *
 * The apps are served under `/data/` and `/managing/` on the VPS, so a
 * hardcoded `"/favicon.png"` 404s in production. `asset("favicon.png")`
 * resolves to `/data/favicon.png` resp. `/managing/favicon.png` in the
 * deployed build and stays `/favicon.png` in dev (base `/`).
 */
export function asset(path: string): string {
  const base = import.meta.env.BASE_URL || "/";
  const cleanBase = base.endsWith("/") ? base : `${base}/`;
  return `${cleanBase}${path.replace(/^\/+/, "")}`;
}
